import React from 'react';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import HowItWorksStrip from '../components/HowItWorksStrip';
import CtaBanner from '../components/CtaBanner';
import HomeContactForm from '../components/HomeContactForm';
import PageMeta from '../components/PageMeta';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ShieldCheck, Headset, Banknote, MapPin } from 'lucide-react';

const whyItems = [
  { icon: ShieldCheck, title: 'Vetted, insured, UK-only', text: 'Every clerk is referenced, DBS-checked and carries £2m PI cover.' },
  { icon: Banknote, title: 'One invoice, every job', text: 'Consolidated billing across every job, every branch — no chasing PO numbers.' },
  { icon: Headset, title: 'A team, not a ticket queue', text: 'A named account manager picks up the phone every time.' },
  { icon: MapPin, title: 'Local clerks, local knowledge', text: 'We know your high street, your stock and your tenants.' },
];

const Home = () => {
  return (
    <div>
      <PageMeta
        title="Residential Support — UK lettings outsourcing partner"
        description="Check-in and check-out inventories, accompanied viewings, photography and floor plans for UK letting agents. One trusted partner, vetted local clerks, every job in your dashboard. Get your week back."
        path="/"
      />
      <Hero />

      <ServicesGrid limit={6} />

      {/* Why us */}
      <section className="sect bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-4 lg:sticky lg:top-28">
              <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-green)] mb-3">Why agencies pick us</div>
              <h2 className="h-display text-4xl md:text-5xl text-[var(--rs-ink)]">
                The reliability of a long-standing partner. The flexibility of an outsourced one.
              </h2>
              <p className="mt-5 text-[var(--rs-ink)]/70">
                We have spent a decade quietly powering UK letting agencies behind the scenes. Here is what that has taught us.
              </p>
              <Link to="/about" className="btn-ghost mt-7">More about us <ArrowUpRight className="w-4 h-4" /></Link>
            </div>
            <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
              {whyItems.map((w, i) => (
                <div key={i} className="rs-card p-6 lift">
                  <div className="w-11 h-11 rounded-lg bg-[var(--rs-coral)]/10 grid place-items-center text-[var(--rs-coral)]">
                    <w.icon className="w-5 h-5" />
                  </div>
                  <h3 className="h-display text-xl text-[var(--rs-ink)] mt-4">{w.title}</h3>
                  <p className="text-sm text-[var(--rs-ink)]/70 mt-2">{w.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <HowItWorksStrip />

      <HomeContactForm />

      <CtaBanner />
    </div>
  );
};

export default Home;
